import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NafathLoginUrlResponse, TokenAuthServiceProxy } from '@shared/service-proxies/service-proxies';
import { NafathWindowService } from 'account/login/nafath-window.service';

@Component({
  selector: 'static-hdr',
  templateUrl: './layout-hdr.component.html',
  styleUrls: ['./layout-hdr.component.scss']
})
export class LayoutHdrComponent implements OnInit {

  public isMenuCollapsed = true;
  loading = false;

  constructor(
    private _tokenAuthService: TokenAuthServiceProxy,
    private _router: Router,
    private _nafathWindowService: NafathWindowService
  ) { }

  get isNafathLoginEnabled(): boolean {
    return abp.setting.getBoolean('App.UserManagement.IsNafathLoginEnabled');
  }

  ngOnInit() { }

  loginWithNafathUrl(): void {
    this.loading = true;
    this._tokenAuthService.nafathLoginUrl().subscribe({
      next: (response: NafathLoginUrlResponse) => {
        this.loading = false;
        this._nafathWindowService.nafathWindow = window.open(response.url, '_blank');
        this._router.navigate(['/account/nafath-callback'], {
          queryParams: { hasedState: response.hasedState },
        });
      },
      error: () => {
        this.loading = false;
      },
    });
  }
}
